import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import appConfig from '../../../config/app-config';
import tokenAwareFetcher from '../../../utils/tokenAwareFetcher';

const COMMUNICATION_ENV = appConfig.apis.communicationApiEnv;
const API_KEY = COMMUNICATION_ENV.key;
const BASE_URL = COMMUNICATION_ENV.address;
const fetcher = tokenAwareFetcher(BASE_URL, API_KEY);

export default function DefaultTemplateGroupsCard() {
  const [defaultGroups, setDefaultGroups] = useState<string[]>([]);
  const [availableGroups, setAvailableGroups] = useState<string[]>([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const [availRes, defaultRes] = await Promise.all([
          fetcher.get(`/templates/group-names`),
          fetcher.get(`/config/default-template-groups`),
        ]);
        if (availRes.ok) setAvailableGroups((await availRes.json()).list || []);
        if (defaultRes.ok) setDefaultGroups((await defaultRes.json()).groups || []);
      } catch (e) { console.error('Failed to fetch groups', e); }
    };
    fetchGroups();
  }, []);

  const toggleGroup = async (group: string) => {
    const updated = defaultGroups.includes(group)
      ? defaultGroups.filter(g => g !== group)
      : [...defaultGroups, group];
    setSaving(true);
    try {
      const res = await fetcher.put(`/config/default-template-groups`, { groups: updated });
      if (res.ok) {
        setDefaultGroups(updated);
        toast.success('Grupos padrão salvos com sucesso');
      } else {
        toast.error('Erro ao salvar grupos padrão');
      }
    } catch {
      toast.error('Erro ao salvar grupos padrão');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow mb-4">
      <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
        <div className="w-1 h-6 bg-green-600 rounded-full"></div>
        Contato — Cadastro
      </h3>
      <p className="text-sm text-gray-500 mb-3">Grupos de templates atribuídos automaticamente aos contact points no cadastro de contatos.</p>
      <div className="space-y-2">
        {availableGroups.map(group => (
          <label key={group} className="flex items-center gap-3 cursor-pointer p-2 rounded hover:bg-gray-50">
            <input
              type="checkbox"
              checked={defaultGroups.includes(group)}
              onChange={() => toggleGroup(group)}
              disabled={saving}
              className="w-4 h-4 text-green-600 border-gray-300 rounded focus:ring-2 focus:ring-green-500"
            />
            <span className="text-sm text-gray-700">{group}</span>
          </label>
        ))}
        {availableGroups.length === 0 && (
          <p className="text-sm text-gray-400">Nenhum grupo disponível. Cadastre grupos nos templates primeiro.</p>
        )}
      </div>
    </div>
  );
}
